import { adjectives, nouns } from './words';

export const randomWords = () => {
  const firstWord = adjectives[Math.floor(adjectives.length * Math.random())];
  const secondWord = nouns[Math.floor(nouns.length * Math.random())];

  return `${firstWord}-${secondWord}`;
}
